export const createProject = project => {
  return (dispatch, getState, { getFirestore }) => {
    
    const firestore = getFirestore();
    const profile = getState().firebase.profile;
    const authorId = getState().firebase.auth.uid;
    firestore
      .collection("projects")
      .add({
        ...project,
        authorFirstName: profile.firstName,
        authorLastName: profile.lastName,
        authorInitials: profile.firstName[0] + profile.lastName[0],
        authorId: authorId,
        createdAt: new Date()
      })
      .then(() => {
        dispatch({ type: "CREATE_PROJECT", project });
      })
      .catch(err => {
        dispatch({ type: "CREATE_PROJECT_ERROR", err });
      });
  };
};

/* export const deleteProject = project => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    
    // const firebase = getFirebase();
    const firestore = getFirestore();
    // const profile = getState().firebase.profile;
    // const authorId = getState().firebase.auth.uid;
    firestore
      .collection("projects")
      .doc()
      .delete({
        ...project
      })
      .then(() => {
        dispatch({ type: "DELETE_PROJECT", project });
      })
      .catch(err => {
        dispatch({ type: "DELETE_PROJECT_ERROR", err });
      });
  };
}; */
